import { defineMessages } from 'react-intl';

export default defineMessages({
	csmRequestsListBannerText: {
		defaultMessage: 'My requests',
		description: 'Text for the banner in the csm requests list page',
		id: 'hub.csm.requests.list.banner.text.non-final',
	},
	customizeMenuLabel: {
		id: 'hub.routes.customize-menu.label',
		defaultMessage: 'Customize',
		description:
			'Accessible label for the customize dropdown menu trigger button in the hub header.',
	},
	manageListViewButtonLabel: {
		id: 'hub.routes.jsm-requests-list.manage-list-view.button.label',
		defaultMessage: 'Manage list view',
		description:
			'Label for the menu item in the customize dropdown that opens the manage columns sidebar on the JSM requests list page.',
	},
});
